import typeCheck from 'common/util/typeCheck';

import {
  SR_API_ACTION_HOUSEHOLD_FIND_BUYERS_AGENT,
} from 'api/actionTypes';

export default async function findBuyersAgent({ state, apiClient }, listingId) {
  typeCheck('listingId::PositiveNumber', listingId);

  const result = await apiClient.postWithState({
    action: SR_API_ACTION_HOUSEHOLD_FIND_BUYERS_AGENT,
    state: state,
    queryId: String(listingId),
    payload: {
      listingId,
    },
    onSuccess(buyerSideAgent) {
      state.set(['household', 'buyersAgentResultsByListingId', listingId], buyerSideAgent);
    },
  });

  return result;
}
